/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address1 } from './Address1';
import {
    Address1FromJSON,
    Address1FromJSONTyped,
    Address1ToJSON,
} from './Address1';
import type { AgentVisit } from './AgentVisit';
import {
    AgentVisitFromJSON,
    AgentVisitFromJSONTyped,
    AgentVisitToJSON,
} from './AgentVisit';
import type { AssignedAgentId } from './AssignedAgentId';
import {
    AssignedAgentIdFromJSON,
    AssignedAgentIdFromJSONTyped,
    AssignedAgentIdToJSON,
} from './AssignedAgentId';
import type { CompletedAt } from './CompletedAt';
import {
    CompletedAtFromJSON,
    CompletedAtFromJSONTyped,
    CompletedAtToJSON,
} from './CompletedAt';
import type { CreatedAt } from './CreatedAt';
import {
    CreatedAtFromJSON,
    CreatedAtFromJSONTyped,
    CreatedAtToJSON,
} from './CreatedAt';
import type { Notes } from './Notes';
import {
    NotesFromJSON,
    NotesFromJSONTyped,
    NotesToJSON,
} from './Notes';
import type { RequestedByUserId } from './RequestedByUserId';
import {
    RequestedByUserIdFromJSON,
    RequestedByUserIdFromJSONTyped,
    RequestedByUserIdToJSON,
} from './RequestedByUserId';
import type { ShowamiRequestId } from './ShowamiRequestId';
import {
    ShowamiRequestIdFromJSON,
    ShowamiRequestIdFromJSONTyped,
    ShowamiRequestIdToJSON,
} from './ShowamiRequestId';
import type { UpdatedAt } from './UpdatedAt';
import {
    UpdatedAtFromJSON,
    UpdatedAtFromJSONTyped,
    UpdatedAtToJSON,
} from './UpdatedAt';
import type { VisitCanStartAt } from './VisitCanStartAt';
import {
    VisitCanStartAtFromJSON,
    VisitCanStartAtFromJSONTyped,
    VisitCanStartAtToJSON,
} from './VisitCanStartAt';
import type { VisitShouldBeCompletedBy } from './VisitShouldBeCompletedBy';
import {
    VisitShouldBeCompletedByFromJSON,
    VisitShouldBeCompletedByFromJSONTyped,
    VisitShouldBeCompletedByToJSON,
} from './VisitShouldBeCompletedBy';
import type { VisitType } from './VisitType';
import {
    VisitTypeFromJSON,
    VisitTypeFromJSONTyped,
    VisitTypeToJSON,
} from './VisitType';

/**
 * 
 * @export
 * @interface AcceptVisitRequestResponseUpdatedVisit
 */
export interface AcceptVisitRequestResponseUpdatedVisit {
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    id: any | null;
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    listingId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    dispositionId?: any | null;
    /**
     * 
     * @type {VisitType}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    visitType?: VisitType;
    /**
     * 
     * @type {Address1}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    address?: Address1;
    /**
     * 
     * @type {Notes}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    notes?: Notes;
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    timeZone: any | null;
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    status: any | null;
    /**
     * 
     * @type {VisitCanStartAt}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    visitCanStartAt?: VisitCanStartAt;
    /**
     * 
     * @type {VisitShouldBeCompletedBy}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    visitShouldBeCompletedBy?: VisitShouldBeCompletedBy;
    /**
     * 
     * @type {CompletedAt}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    completedAt?: CompletedAt;
    /**
     * 
     * @type {AssignedAgentId}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    assignedAgentId?: AssignedAgentId;
    /**
     * 
     * @type {ShowamiRequestId}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    showamiRequestId?: ShowamiRequestId;
    /**
     * 
     * @type {RequestedByUserId}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    requestedByUserId?: RequestedByUserId;
    /**
     * 
     * @type {any}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    manuallyAssignedAt?: any | null;
    /**
     * 
     * @type {CreatedAt}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    createdAt?: CreatedAt;
    /**
     * 
     * @type {UpdatedAt}
     * @memberof AcceptVisitRequestResponseUpdatedVisit
     */
    updatedAt?: UpdatedAt;
}

/**
 * Check if a given object implements the AcceptVisitRequestResponseUpdatedVisit interface.
 */
export function instanceOfAcceptVisitRequestResponseUpdatedVisit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "timeZone" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function AcceptVisitRequestResponseUpdatedVisitFromJSON(json: any): AcceptVisitRequestResponseUpdatedVisit {
    return AcceptVisitRequestResponseUpdatedVisitFromJSONTyped(json, false);
}

export function AcceptVisitRequestResponseUpdatedVisitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptVisitRequestResponseUpdatedVisit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listingId': !exists(json, 'listing_id') ? undefined : json['listing_id'],
        'dispositionId': !exists(json, 'disposition_id') ? undefined : json['disposition_id'],
        'visitType': !exists(json, 'visit_type') ? undefined : VisitTypeFromJSON(json['visit_type']),
        'address': !exists(json, 'address') ? undefined : Address1FromJSON(json['address']),
        'notes': !exists(json, 'notes') ? undefined : NotesFromJSON(json['notes']),
        'timeZone': json['time_zone'],
        'status': json['status'],
        'visitCanStartAt': !exists(json, 'visit_can_start_at') ? undefined : VisitCanStartAtFromJSON(json['visit_can_start_at']),
        'visitShouldBeCompletedBy': !exists(json, 'visit_should_be_completed_by') ? undefined : VisitShouldBeCompletedByFromJSON(json['visit_should_be_completed_by']),
        'completedAt': !exists(json, 'completed_at') ? undefined : CompletedAtFromJSON(json['completed_at']),
        'assignedAgentId': !exists(json, 'assigned_agent_id') ? undefined : AssignedAgentIdFromJSON(json['assigned_agent_id']),
        'showamiRequestId': !exists(json, 'showami_request_id') ? undefined : ShowamiRequestIdFromJSON(json['showami_request_id']),
        'requestedByUserId': !exists(json, 'requested_by_user_id') ? undefined : RequestedByUserIdFromJSON(json['requested_by_user_id']),
        'manuallyAssignedAt': !exists(json, 'manually_assigned_at') ? undefined : json['manually_assigned_at'],
        'createdAt': !exists(json, 'created_at') ? undefined : CreatedAtFromJSON(json['created_at']),
        'updatedAt': !exists(json, 'updated_at') ? undefined : UpdatedAtFromJSON(json['updated_at']),
    };
}

export function AcceptVisitRequestResponseUpdatedVisitToJSON(value?: AcceptVisitRequestResponseUpdatedVisit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listing_id': value.listingId,
        'disposition_id': value.dispositionId,
        'visit_type': VisitTypeToJSON(value.visitType),
        'address': Address1ToJSON(value.address),
        'notes': NotesToJSON(value.notes),
        'time_zone': value.timeZone,
        'status': value.status,
        'visit_can_start_at': VisitCanStartAtToJSON(value.visitCanStartAt),
        'visit_should_be_completed_by': VisitShouldBeCompletedByToJSON(value.visitShouldBeCompletedBy),
        'completed_at': CompletedAtToJSON(value.completedAt),
        'assigned_agent_id': AssignedAgentIdToJSON(value.assignedAgentId),
        'showami_request_id': ShowamiRequestIdToJSON(value.showamiRequestId),
        'requested_by_user_id': RequestedByUserIdToJSON(value.requestedByUserId),
        'manually_assigned_at': value.manuallyAssignedAt,
        'created_at': CreatedAtToJSON(value.createdAt),
        'updated_at': UpdatedAtToJSON(value.updatedAt),
    };
}

